import React, { useState, useEffect, useLayoutEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import Webcam from "react-webcam";
import { uploadUserDocument } from "api/formDisplay";
import "./index.scss";
import DocumentUploaded from "./documentUploaded";
import { Container, Row, Col } from "react-bootstrap";
const Capture = (props) => {
 
  const {
    name,
    setUploaded,
    setFileName,
    setFileSize,
    setSelectedData,
    label,
    userInfo,
    clearFieldError,
    docType,
    getRootProps,
    getInputProps,
    handleOnDropAccepted
  } = props;
  const dispatch = useDispatch();
  const [picture, setPicture] = useState("");
  const [cameraMode, setCameraMode] = useState('user') 
  const [changeCamera, setChangeCamera] = useState(false)
  let videoConstraints = {
    width: 300,
    height: 230,
    facingMode: cameraMode,
  };
  const webcamRef = React.useRef(null);
  const capture = React.useCallback(() => {
    const pictureSrc = webcamRef.current.getScreenshot();
    setPicture(pictureSrc);
  });
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };
  const toggleCamera = () =>{
    setChangeCamera(!changeCamera)
   setCameraMode(changeCamera ? 'user': 'environment')
   console.log(cameraMode);
  }
  const saveImage = () => {
    const file = dataURLtoFile(picture, "profile.jpeg");
    let acceptedFile = [];
    let fileData = {
      file: file,
      file_path: file.name,
      file_size: file.size,
    };
    acceptedFile.push(file);
    setFileName(fileData.file_path);
    setFileSize(fileData.file_size);
    clearFieldError && clearFieldError(name);
    if (docType) {
      handleOnDropAccepted(acceptedFile,[])
    }
    else {
      dispatch(
        uploadUserDocument({
          acceptedFile,
          name,
          userInfo,
          userInfo,
          label,
          setSelectedData,
        })
      );
    }
    setShow(false);
    setUploaded(true);
  };
  return (
    <>
      <div className="capture_container">
        <p>- or -</p>
        <div
          className="file-uploader px-3 d-flex align-items-center"
          onClick={handleShow}
        >
          <svg
            className="mb-1 me-2"
            id="Group_29551"
            data-name="Group 29551"
            xmlns="http://www.w3.org/2000/svg"
            width="22.379"
            height="17.909"
            viewBox="0 0 22.379 17.909"
          >
            <g id="Group_29541" data-name="Group 29541">
              <path
                id="Path_23773"
                data-name="Path 23773"
                d="M149.213,322.5q-4.5,0-8.99,0a2.06,2.06,0,0,1-2.133-1.6,2.442,2.442,0,0,1-.043-.571q0-5.385,0-10.771a2.023,2.023,0,0,1,2.165-2.171q1.881,0,3.763,0a1.119,1.119,0,0,0,1.28-.934c.046-.146.094-.29.143-.435a2,2,0,0,1,1.919-1.417q1.91-.021,3.82,0a2.007,2.007,0,0,1,1.921,1.415c.061.181.114.364.173.546a1.074,1.074,0,0,0,1.1.824c.316.007,5.24.022,5.555.03a.486.486,0,1,1,.026.971c-.439.012-5.489.017-5.927-.048a1.986,1.986,0,0,1-1.669-1.389c-.068-.188-.117-.383-.181-.573a1.032,1.032,0,0,0-1.035-.794q-1.881-.018-3.763,0a1.026,1.026,0,0,0-1.022.771c-.056.162-.106.327-.158.49a2.037,2.037,0,0,1-2.048,1.522c-1.3.006-2.6,0-3.906,0a1.048,1.048,0,0,0-1.182,1.183q0,5.385,0,10.771a1.074,1.074,0,0,0,1.207,1.2h17.981a1.087,1.087,0,0,0,1.215-1.225c0-2.528.013-7.794.013-10.321,0-.086,0-.173,0-.258a.488.488,0,0,1,.47-.454.5.5,0,0,1,.5.425,1.761,1.761,0,0,1,.007.258c0,2.537-.012,7.813-.013,10.35a2.055,2.055,0,0,1-2.207,2.2Q153.708,322.5,149.213,322.5Z"
                transform="translate(-138.046 -304.588)"
                fill="#a0b6c9"
              />
              <path
                id="Path_23774"
                data-name="Path 23774"
                d="M228.7,379.365a4.984,4.984,0,1,1-4.964-5A4.993,4.993,0,0,1,228.7,379.365Zm-4.992-4.01a4,4,0,1,0,4.013,3.98A4,4,0,0,0,223.709,375.355Z"
                transform="translate(-212.537 -369.006)"
                fill="#a0b6c9"
              />
              <path
                id="Path_23777"
                data-name="Path 23777"
                d="M250.332,408.556a2.561,2.561,0,0,1,5.123-.01,2.561,2.561,0,1,1-5.123.01Zm.98-.01a1.581,1.581,0,1,0,1.595-1.567A1.567,1.567,0,0,0,251.312,408.546Z"
                transform="translate(-241.71 -398.204)"
                fill="#a0b6c9"
              />
            </g>
          </svg>
          Capture image
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        scrollable
        id="capture-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Capture Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column justify-content-around text-center">
          <div className="webcam" >
            {picture == "" ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                width={"95%"}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
              />
            ) : (
              <img src={picture} className="img-captured" />
            )}
             {
                   picture === "" ? (
                    <button className="btn position-absolute bottom-0 end-0 me-4  mb-5 mb-lg-0 border-0 shadow-none bg-transparent-dark" styleClass="position: absolute !important;"  onClick={toggleCamera}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.006" height="19.005" viewBox="0 0 19.006 19.005">
                    <g id="Layer_33" data-name="Layer 33" transform="translate(-1.947 -1.948)">
                      <path id="Path_56722" data-name="Path 56722" d="M12.569,3.14A9.368,9.368,0,0,0,10.5,4.673a.61.61,0,0,0-.145.155v.019a.079.079,0,0,1,0,.022.632.632,0,0,0,0,.632V5.52l.016.022a.632.632,0,0,0,.515.269h3.739a.632.632,0,0,0,0-1.264H12.661C19.8-.027,28.394,7.925,24.355,15.4a.637.637,0,0,0,1.106.632A9.511,9.511,0,0,0,12.569,3.14Z" transform="translate(-5.694 0)" fill="#fff"/>
                      <path id="Path_56723" data-name="Path 56723" d="M18.247,27.975a.632.632,0,0,0,0-.632V27.3a.632.632,0,0,0-.515-.269H14.173a.632.632,0,0,0,0,1.264H15.9A8.226,8.226,0,0,1,4.246,17.438a.632.632,0,1,0-1.106-.613C-1.9,26.455,10.181,35.64,18.083,28.171a.61.61,0,0,0,.145-.155V28A.079.079,0,0,1,18.247,27.975Z" transform="translate(0 -9.952)" fill="#fff"/>
                      <path id="Path_56724" data-name="Path 56724" d="M27.568,26.62a2.051,2.051,0,1,0,1.455.6A2.051,2.051,0,0,0,27.568,26.62Z" transform="translate(-16.123 -16.874)" fill="#fff"/>
                      <path id="Path_56725" data-name="Path 56725" d="M24.646,18.6H23.609a.063.063,0,0,1-.057-.038l-.291-.872A1,1,0,0,0,22.313,17H18.1a1,1,0,0,0-.948.689l-.291.869a.06.06,0,0,1-.057.041H15.758a1.008,1.008,0,0,0-1.008,1.008v5.866a1.008,1.008,0,0,0,1.008,1.008h8.888a1.008,1.008,0,0,0,1.008-1.008V19.607A1.008,1.008,0,0,0,24.646,18.6ZM20.2,25.085a3,3,0,1,1,2.126-.874A3,3,0,0,1,20.2,25.085Z" transform="translate(-8.757 -10.294)" fill="#fff"/>
                    </g>
                  </svg>
                    </button>
                  ) : (<></>)
                }
          </div>
          <div>
            {picture != "" ? (
              <>
                          <input {...getInputProps()} />

                <button
                  onClick={(e) => {
                    setPicture("");
                  }}
                  className="btn btn-warning mt-2"
                >
                  Re-Capture
                </button>
                <button
                  onClick={() => {
                    saveImage();
                  }}
                  className="btn btn-primary mt-2 ms-2"
                >
                  Save
                </button>
              </>
            ) : (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  capture();
                }}
                className="btn btn-primary"
              >
                Capture
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Capture;
